import {
  Dialog,
  DialogContent,
  DialogTitle,
  makeStyles,
  Typography,
} from '@material-ui/core';
import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { Box, Divider } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center', // push the dialog to bottom
  },
  paper: {
    // make the content full width
    // maxWidth:'480px',
    margin: '0 auto',
    // maxWidth: "100%",
    width: '85%',
    // height: "220px"
    borderRadius: '60px',
    padding: '40px',
  },
}));

const PopUpDialogBox = (props: any) => {
  const { toggle, title, image, handleClose, handleYes, buttonTitle, success } =
    props;
  const classes = useStyles();
  return (
    <Dialog
      open={toggle}
      onClose={handleClose}
      className='paDialogue'
      classes={{ container: classes.root, paper: classes.paper }}
    >
      <DialogTitle style={{ padding: '0' }}>
        {
          !success &&
        <Box sx={{ textAlign: 'right' }}>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        }
      </DialogTitle>
      {title && (
        <Box className='PendingInvestmentPopup'>
          <DialogContent style={{ textAlign: 'center' }}>
            <Box className='infoDialogueIcon'>
              <InfoOutlinedIcon />
            </Box>
            <Typography variant='h4'>pending investment</Typography>
            <Typography>
            Pending investments may take up to 48 hours to be allocated to the borrowers
            </Typography>
            <Divider />
            <Typography>
              You start earning interest on your investments once borrowers are
              allocated
            </Typography>
          </DialogContent>
        </Box>
      )}
      {image && (
        <Card className='redBorder'>
          <CardContent>
            <DialogContent>
              <div className='text-center'>
                <img src={image} alt='' />
              </div>
              {success ? (
                <Box className='popupText'>
                  <Typography>
                    Successful <br />
                    withdrawal
                  </Typography>
                </Box>
              ) : (
                <Box className='popupText'>
                  <Typography>
                    Are you sure you <br /> want to withdraw
                    <br /> your funds?
                  </Typography>
                </Box>
              )}
              <div className='text-center'>
                <Button
                  onClick={handleYes}
                  variant='contained'
                  className='btnBlue small no-shadow'
                >
                  {buttonTitle}
                </Button>
              </div>
            </DialogContent>
          </CardContent>
        </Card>
      )}
    </Dialog>
  );
};

export default PopUpDialogBox;
